import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/appelit.webp';
import screenshot_target from '../../../images/letterfunnel/johannesgergin.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Johannes Gergin"
      firstname="Johannes"
      companyname="APPelit"
      competition="DTT en Label A"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/johannesgergin.js